/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    AddEditCommissionGroupBodyBody,
    AssignUserCommissionGroupBodyBody,
    CommissionGroupAssignmentSuccessResponseResponse,
    CommissionGroupBookingsSuccessResponseResponse,
    CommissionGroupCreateSuccessResponseResponse,
    CommissionGroupMemberSuccessResponseResponse,
    CommissionGroupMembersSuccessResponseResponse,
    CommissionGroupSuccessResponseResponse,
    CommissionGroupsSuccessResponseResponse,
    CreateCommissionGroupStripeCustomer200,
    GetCommissionGroupBookingsParams,
    GetCommissionGroupCards200,
    GetVenueCommissionGroups200,
    InviteAgentToCommissionGroupBodyBody,
    MigrateCommissionGroupPaymentType200,
    MigrateCommissionGroupPaymentTypeBody,
    PublicSetupPaymentMethod200,
    RequestStatusResponseResponse,
    SetupCommissionGroupPayment200,
    UserCommissionGroupsSuccessResponseResponse,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Public endpoint to create SetupIntent for adding a payment method to a Stripe customer
 */
export const publicSetupPaymentMethod = (
    stripeCustomerId: string,
    hash: string,
    signal?: AbortSignal,
) => {
    return customInstance<PublicSetupPaymentMethod200>({
        url: `/public/setup-payment/${stripeCustomerId}/${hash}`,
        method: 'POST',
        signal,
    });
};

export const getPublicSetupPaymentMethodMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof publicSetupPaymentMethod>>,
        TError,
        { stripeCustomerId: string; hash: string },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof publicSetupPaymentMethod>>,
    TError,
    { stripeCustomerId: string; hash: string },
    TContext
> => {
    const mutationKey = ['publicSetupPaymentMethod'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof publicSetupPaymentMethod>>,
        { stripeCustomerId: string; hash: string }
    > = (props) => {
        const { stripeCustomerId, hash } = props ?? {};

        return publicSetupPaymentMethod(stripeCustomerId, hash);
    };

    return { mutationFn, ...mutationOptions };
};

export type PublicSetupPaymentMethodMutationResult = NonNullable<
    Awaited<ReturnType<typeof publicSetupPaymentMethod>>
>;

export type PublicSetupPaymentMethodMutationError = APIErrorResponseResponse;

/**
 * @summary Public endpoint to create SetupIntent for adding a payment method to a Stripe customer
 */
export const usePublicSetupPaymentMethod = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof publicSetupPaymentMethod>>,
        TError,
        { stripeCustomerId: string; hash: string },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof publicSetupPaymentMethod>>,
    TError,
    { stripeCustomerId: string; hash: string },
    TContext
> => {
    const mutationOptions = getPublicSetupPaymentMethodMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get commission groups for a show
 */
export const getCommissionGroups = (showId: number, signal?: AbortSignal) => {
    return customInstance<CommissionGroupsSuccessResponseResponse>({
        url: `/shows/${showId}/commission-groups`,
        method: 'GET',
        signal,
    });
};

export const getGetCommissionGroupsQueryKey = (showId?: number) => {
    return [`/shows/${showId}/commission-groups`] as const;
};

export const getGetCommissionGroupsQueryOptions = <
    TData = Awaited<ReturnType<typeof getCommissionGroups>>,
    TError = APIErrorResponseResponse,
>(
    showId: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getCommissionGroups>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCommissionGroupsQueryKey(showId);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommissionGroups>>> = ({ signal }) =>
        getCommissionGroups(showId, signal);

    return { queryKey, queryFn, enabled: !!showId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getCommissionGroups>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetCommissionGroupsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getCommissionGroups>>
>;
export type GetCommissionGroupsQueryError = APIErrorResponseResponse;

/**
 * @summary Get commission groups for a show
 */

export function useGetCommissionGroups<
    TData = Awaited<ReturnType<typeof getCommissionGroups>>,
    TError = APIErrorResponseResponse,
>(
    showId: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getCommissionGroups>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetCommissionGroupsQueryOptions(showId, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Add a commission group to a show
 */
export const addCommissionGroup = (
    showId: number,
    addEditCommissionGroupBodyBody: AddEditCommissionGroupBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<CommissionGroupCreateSuccessResponseResponse>({
        url: `/shows/${showId}/commission-groups`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addEditCommissionGroupBodyBody,
        signal,
    });
};

export const getAddCommissionGroupMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addCommissionGroup>>,
        TError,
        { showId: number; data: AddEditCommissionGroupBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof addCommissionGroup>>,
    TError,
    { showId: number; data: AddEditCommissionGroupBodyBody },
    TContext
> => {
    const mutationKey = ['addCommissionGroup'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof addCommissionGroup>>,
        { showId: number; data: AddEditCommissionGroupBodyBody }
    > = (props) => {
        const { showId, data } = props ?? {};

        return addCommissionGroup(showId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AddCommissionGroupMutationResult = NonNullable<
    Awaited<ReturnType<typeof addCommissionGroup>>
>;
export type AddCommissionGroupMutationBody = AddEditCommissionGroupBodyBody;
export type AddCommissionGroupMutationError = APIErrorResponseResponse;

/**
 * @summary Add a commission group to a show
 */
export const useAddCommissionGroup = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof addCommissionGroup>>,
        TError,
        { showId: number; data: AddEditCommissionGroupBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof addCommissionGroup>>,
    TError,
    { showId: number; data: AddEditCommissionGroupBodyBody },
    TContext
> => {
    const mutationOptions = getAddCommissionGroupMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get a commission group by ID
 */
export const getCommissionGroup = (id: number, signal?: AbortSignal) => {
    return customInstance<CommissionGroupSuccessResponseResponse>({
        url: `/commission-groups/${id}`,
        method: 'GET',
        signal,
    });
};

export const getGetCommissionGroupQueryKey = (id?: number) => {
    return [`/commission-groups/${id}`] as const;
};

export const getGetCommissionGroupQueryOptions = <
    TData = Awaited<ReturnType<typeof getCommissionGroup>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getCommissionGroup>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCommissionGroupQueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommissionGroup>>> = ({ signal }) =>
        getCommissionGroup(id, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getCommissionGroup>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetCommissionGroupQueryResult = NonNullable<
    Awaited<ReturnType<typeof getCommissionGroup>>
>;
export type GetCommissionGroupQueryError = APIErrorResponseResponse;

/**
 * @summary Get a commission group by ID
 */

export function useGetCommissionGroup<
    TData = Awaited<ReturnType<typeof getCommissionGroup>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getCommissionGroup>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetCommissionGroupQueryOptions(id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Edit a commission group
 */
export const editCommissionGroup = (
    id: number,
    addEditCommissionGroupBodyBody: AddEditCommissionGroupBodyBody,
) => {
    return customInstance<CommissionGroupSuccessResponseResponse>({
        url: `/commission-groups/${id}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: addEditCommissionGroupBodyBody,
    });
};

export const getEditCommissionGroupMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editCommissionGroup>>,
        TError,
        { id: number; data: AddEditCommissionGroupBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editCommissionGroup>>,
    TError,
    { id: number; data: AddEditCommissionGroupBodyBody },
    TContext
> => {
    const mutationKey = ['editCommissionGroup'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editCommissionGroup>>,
        { id: number; data: AddEditCommissionGroupBodyBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return editCommissionGroup(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditCommissionGroupMutationResult = NonNullable<
    Awaited<ReturnType<typeof editCommissionGroup>>
>;
export type EditCommissionGroupMutationBody = AddEditCommissionGroupBodyBody;
export type EditCommissionGroupMutationError = APIErrorResponseResponse;

/**
 * @summary Edit a commission group
 */
export const useEditCommissionGroup = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editCommissionGroup>>,
        TError,
        { id: number; data: AddEditCommissionGroupBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editCommissionGroup>>,
    TError,
    { id: number; data: AddEditCommissionGroupBodyBody },
    TContext
> => {
    const mutationOptions = getEditCommissionGroupMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Delete a commission group
 */
export const deleteCommissionGroup = (id: number) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/commission-groups/${id}`,
        method: 'DELETE',
    });
};

export const getDeleteCommissionGroupMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteCommissionGroup>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteCommissionGroup>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['deleteCommissionGroup'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteCommissionGroup>>,
        { id: number }
    > = (props) => {
        const { id } = props ?? {};

        return deleteCommissionGroup(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteCommissionGroupMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteCommissionGroup>>
>;

export type DeleteCommissionGroupMutationError = APIErrorResponseResponse;

/**
 * @summary Delete a commission group
 */
export const useDeleteCommissionGroup = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteCommissionGroup>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof deleteCommissionGroup>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationOptions = getDeleteCommissionGroupMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Create or get Stripe customer for a commission group
 */
export const createCommissionGroupStripeCustomer = (id: number, signal?: AbortSignal) => {
    return customInstance<CreateCommissionGroupStripeCustomer200>({
        url: `/commission-groups/${id}/stripe-customer`,
        method: 'POST',
        signal,
    });
};

export const getCreateCommissionGroupStripeCustomerMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof createCommissionGroupStripeCustomer>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof createCommissionGroupStripeCustomer>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['createCommissionGroupStripeCustomer'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof createCommissionGroupStripeCustomer>>,
        { id: number }
    > = (props) => {
        const { id } = props ?? {};

        return createCommissionGroupStripeCustomer(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type CreateCommissionGroupStripeCustomerMutationResult = NonNullable<
    Awaited<ReturnType<typeof createCommissionGroupStripeCustomer>>
>;

export type CreateCommissionGroupStripeCustomerMutationError = APIErrorResponseResponse;

/**
 * @summary Create or get Stripe customer for a commission group
 */
export const useCreateCommissionGroupStripeCustomer = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof createCommissionGroupStripeCustomer>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof createCommissionGroupStripeCustomer>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationOptions = getCreateCommissionGroupStripeCustomerMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Create SetupIntent for commission group payment method
 */
export const setupCommissionGroupPayment = (id: number, signal?: AbortSignal) => {
    return customInstance<SetupCommissionGroupPayment200>({
        url: `/commission-groups/${id}/setup-payment`,
        method: 'POST',
        signal,
    });
};

export const getSetupCommissionGroupPaymentMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof setupCommissionGroupPayment>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof setupCommissionGroupPayment>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['setupCommissionGroupPayment'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof setupCommissionGroupPayment>>,
        { id: number }
    > = (props) => {
        const { id } = props ?? {};

        return setupCommissionGroupPayment(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type SetupCommissionGroupPaymentMutationResult = NonNullable<
    Awaited<ReturnType<typeof setupCommissionGroupPayment>>
>;

export type SetupCommissionGroupPaymentMutationError = APIErrorResponseResponse;

/**
 * @summary Create SetupIntent for commission group payment method
 */
export const useSetupCommissionGroupPayment = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof setupCommissionGroupPayment>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof setupCommissionGroupPayment>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationOptions = getSetupCommissionGroupPaymentMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary List the saved company cards for a commission group's Stripe customer
 */
export const getCommissionGroupCards = (id: number, signal?: AbortSignal) => {
    return customInstance<GetCommissionGroupCards200>({
        url: `/commission-groups/${id}/cards`,
        method: 'GET',
        signal,
    });
};

export const getGetCommissionGroupCardsQueryKey = (id?: number) => {
    return [`/commission-groups/${id}/cards`] as const;
};

export const getGetCommissionGroupCardsQueryOptions = <
    TData = Awaited<ReturnType<typeof getCommissionGroupCards>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getCommissionGroupCards>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCommissionGroupCardsQueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommissionGroupCards>>> = ({
        signal,
    }) => getCommissionGroupCards(id, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getCommissionGroupCards>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetCommissionGroupCardsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getCommissionGroupCards>>
>;
export type GetCommissionGroupCardsQueryError = APIErrorResponseResponse;

/**
 * @summary List the saved company cards for a commission group's Stripe customer
 */

export function useGetCommissionGroupCards<
    TData = Awaited<ReturnType<typeof getCommissionGroupCards>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getCommissionGroupCards>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetCommissionGroupCardsQueryOptions(id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Get all commission groups for a venue (superadmin/manager access)
 */
export const getVenueCommissionGroups = (venueId: number, signal?: AbortSignal) => {
    return customInstance<GetVenueCommissionGroups200>({
        url: `/venues/${venueId}/commission-groups`,
        method: 'GET',
        signal,
    });
};

export const getGetVenueCommissionGroupsQueryKey = (venueId?: number) => {
    return [`/venues/${venueId}/commission-groups`] as const;
};

export const getGetVenueCommissionGroupsQueryOptions = <
    TData = Awaited<ReturnType<typeof getVenueCommissionGroups>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getVenueCommissionGroups>>,
            TError,
            TData
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetVenueCommissionGroupsQueryKey(venueId);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVenueCommissionGroups>>> = ({
        signal,
    }) => getVenueCommissionGroups(venueId, signal);

    return { queryKey, queryFn, enabled: !!venueId, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getVenueCommissionGroups>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetVenueCommissionGroupsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getVenueCommissionGroups>>
>;
export type GetVenueCommissionGroupsQueryError = APIErrorResponseResponse;

/**
 * @summary Get all commission groups for a venue (superadmin/manager access)
 */

export function useGetVenueCommissionGroups<
    TData = Awaited<ReturnType<typeof getVenueCommissionGroups>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getVenueCommissionGroups>>,
            TError,
            TData
        >;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetVenueCommissionGroupsQueryOptions(venueId, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Bulk-migrate this commission group's bookings from a legacy payment type onto the group's own payment type
 */
export const migrateCommissionGroupPaymentType = (
    id: number,
    migrateCommissionGroupPaymentTypeBody: MigrateCommissionGroupPaymentTypeBody,
    signal?: AbortSignal,
) => {
    return customInstance<MigrateCommissionGroupPaymentType200>({
        url: `/commission-groups/${id}/migrate-payment-type`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: migrateCommissionGroupPaymentTypeBody,
        signal,
    });
};

export const getMigrateCommissionGroupPaymentTypeMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof migrateCommissionGroupPaymentType>>,
        TError,
        { id: number; data: MigrateCommissionGroupPaymentTypeBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof migrateCommissionGroupPaymentType>>,
    TError,
    { id: number; data: MigrateCommissionGroupPaymentTypeBody },
    TContext
> => {
    const mutationKey = ['migrateCommissionGroupPaymentType'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof migrateCommissionGroupPaymentType>>,
        { id: number; data: MigrateCommissionGroupPaymentTypeBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return migrateCommissionGroupPaymentType(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type MigrateCommissionGroupPaymentTypeMutationResult = NonNullable<
    Awaited<ReturnType<typeof migrateCommissionGroupPaymentType>>
>;
export type MigrateCommissionGroupPaymentTypeMutationBody = MigrateCommissionGroupPaymentTypeBody;
export type MigrateCommissionGroupPaymentTypeMutationError = APIErrorResponseResponse;

/**
 * @summary Bulk-migrate this commission group's bookings from a legacy payment type onto the group's own payment type
 */
export const useMigrateCommissionGroupPaymentType = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof migrateCommissionGroupPaymentType>>,
        TError,
        { id: number; data: MigrateCommissionGroupPaymentTypeBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof migrateCommissionGroupPaymentType>>,
    TError,
    { id: number; data: MigrateCommissionGroupPaymentTypeBody },
    TContext
> => {
    const mutationOptions = getMigrateCommissionGroupPaymentTypeMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get commission group assignments for a user in a venue
 */
export const getUserCommissionGroups = (venueId: number, userId: number, signal?: AbortSignal) => {
    return customInstance<UserCommissionGroupsSuccessResponseResponse>({
        url: `/venues/${venueId}/users/${userId}/commission-groups`,
        method: 'GET',
        signal,
    });
};

export const getGetUserCommissionGroupsQueryKey = (venueId?: number, userId?: number) => {
    return [`/venues/${venueId}/users/${userId}/commission-groups`] as const;
};

export const getGetUserCommissionGroupsQueryOptions = <
    TData = Awaited<ReturnType<typeof getUserCommissionGroups>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    userId: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getUserCommissionGroups>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUserCommissionGroupsQueryKey(venueId, userId);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserCommissionGroups>>> = ({
        signal,
    }) => getUserCommissionGroups(venueId, userId, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!(venueId && userId),
        ...queryOptions,
    } as UseQueryOptions<Awaited<ReturnType<typeof getUserCommissionGroups>>, TError, TData> & {
        queryKey: QueryKey;
    };
};

export type GetUserCommissionGroupsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUserCommissionGroups>>
>;
export type GetUserCommissionGroupsQueryError = APIErrorResponseResponse;

/**
 * @summary Get commission group assignments for a user in a venue
 */

export function useGetUserCommissionGroups<
    TData = Awaited<ReturnType<typeof getUserCommissionGroups>>,
    TError = APIErrorResponseResponse,
>(
    venueId: number,
    userId: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getUserCommissionGroups>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetUserCommissionGroupsQueryOptions(venueId, userId, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Assign a user to a commission group
 */
export const assignUserCommissionGroup = (
    assignUserCommissionGroupBodyBody: AssignUserCommissionGroupBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<CommissionGroupAssignmentSuccessResponseResponse>({
        url: `/commission-group-assignments`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: assignUserCommissionGroupBodyBody,
        signal,
    });
};

export const getAssignUserCommissionGroupMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof assignUserCommissionGroup>>,
        TError,
        { data: AssignUserCommissionGroupBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof assignUserCommissionGroup>>,
    TError,
    { data: AssignUserCommissionGroupBodyBody },
    TContext
> => {
    const mutationKey = ['assignUserCommissionGroup'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof assignUserCommissionGroup>>,
        { data: AssignUserCommissionGroupBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return assignUserCommissionGroup(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type AssignUserCommissionGroupMutationResult = NonNullable<
    Awaited<ReturnType<typeof assignUserCommissionGroup>>
>;
export type AssignUserCommissionGroupMutationBody = AssignUserCommissionGroupBodyBody;
export type AssignUserCommissionGroupMutationError = APIErrorResponseResponse;

/**
 * @summary Assign a user to a commission group
 */
export const useAssignUserCommissionGroup = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof assignUserCommissionGroup>>,
        TError,
        { data: AssignUserCommissionGroupBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof assignUserCommissionGroup>>,
    TError,
    { data: AssignUserCommissionGroupBodyBody },
    TContext
> => {
    const mutationOptions = getAssignUserCommissionGroupMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Remove a user from a commission group
 */
export const removeUserCommissionGroup = (id: number) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/commission-group-assignments/${id}`,
        method: 'DELETE',
    });
};

export const getRemoveUserCommissionGroupMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof removeUserCommissionGroup>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof removeUserCommissionGroup>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationKey = ['removeUserCommissionGroup'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof removeUserCommissionGroup>>,
        { id: number }
    > = (props) => {
        const { id } = props ?? {};

        return removeUserCommissionGroup(id);
    };

    return { mutationFn, ...mutationOptions };
};

export type RemoveUserCommissionGroupMutationResult = NonNullable<
    Awaited<ReturnType<typeof removeUserCommissionGroup>>
>;

export type RemoveUserCommissionGroupMutationError = APIErrorResponseResponse;

/**
 * @summary Remove a user from a commission group
 */
export const useRemoveUserCommissionGroup = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof removeUserCommissionGroup>>,
        TError,
        { id: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof removeUserCommissionGroup>>,
    TError,
    { id: number },
    TContext
> => {
    const mutationOptions = getRemoveUserCommissionGroupMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get members of a commission group
 */
export const getCommissionGroupMembers = (id: number, signal?: AbortSignal) => {
    return customInstance<CommissionGroupMembersSuccessResponseResponse>({
        url: `/commission-groups/${id}/members`,
        method: 'GET',
        signal,
    });
};

export const getGetCommissionGroupMembersQueryKey = (id?: number) => {
    return [`/commission-groups/${id}/members`] as const;
};

export const getGetCommissionGroupMembersQueryOptions = <
    TData = Awaited<ReturnType<typeof getCommissionGroupMembers>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getCommissionGroupMembers>>,
            TError,
            TData
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCommissionGroupMembersQueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommissionGroupMembers>>> = ({
        signal,
    }) => getCommissionGroupMembers(id, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getCommissionGroupMembers>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetCommissionGroupMembersQueryResult = NonNullable<
    Awaited<ReturnType<typeof getCommissionGroupMembers>>
>;
export type GetCommissionGroupMembersQueryError = APIErrorResponseResponse;

/**
 * @summary Get members of a commission group
 */

export function useGetCommissionGroupMembers<
    TData = Awaited<ReturnType<typeof getCommissionGroupMembers>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getCommissionGroupMembers>>,
            TError,
            TData
        >;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetCommissionGroupMembersQueryOptions(id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * Adds the agent to the group, minting an affiliate code for them, and emails them a welcome with that code and their booking link. A brand new account also gets a set-password link. Inviting someone who is already in the group resends the welcome instead of creating a second assignment.
 * @summary Invite an agent to a commission group by email
 */
export const inviteAgentToCommissionGroup = (
    id: number,
    inviteAgentToCommissionGroupBodyBody: InviteAgentToCommissionGroupBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<CommissionGroupMemberSuccessResponseResponse>({
        url: `/commission-groups/${id}/members`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: inviteAgentToCommissionGroupBodyBody,
        signal,
    });
};

export const getInviteAgentToCommissionGroupMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof inviteAgentToCommissionGroup>>,
        TError,
        { id: number; data: InviteAgentToCommissionGroupBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof inviteAgentToCommissionGroup>>,
    TError,
    { id: number; data: InviteAgentToCommissionGroupBodyBody },
    TContext
> => {
    const mutationKey = ['inviteAgentToCommissionGroup'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof inviteAgentToCommissionGroup>>,
        { id: number; data: InviteAgentToCommissionGroupBodyBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return inviteAgentToCommissionGroup(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type InviteAgentToCommissionGroupMutationResult = NonNullable<
    Awaited<ReturnType<typeof inviteAgentToCommissionGroup>>
>;
export type InviteAgentToCommissionGroupMutationBody = InviteAgentToCommissionGroupBodyBody;
export type InviteAgentToCommissionGroupMutationError = APIErrorResponseResponse;

/**
 * @summary Invite an agent to a commission group by email
 */
export const useInviteAgentToCommissionGroup = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof inviteAgentToCommissionGroup>>,
        TError,
        { id: number; data: InviteAgentToCommissionGroupBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof inviteAgentToCommissionGroup>>,
    TError,
    { id: number; data: InviteAgentToCommissionGroupBodyBody },
    TContext
> => {
    const mutationOptions = getInviteAgentToCommissionGroupMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Remove a member from a commission group
 */
export const removeCommissionGroupMember = (id: number, assignmentId: number) => {
    return customInstance<RequestStatusResponseResponse>({
        url: `/commission-groups/${id}/members/${assignmentId}`,
        method: 'DELETE',
    });
};

export const getRemoveCommissionGroupMemberMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof removeCommissionGroupMember>>,
        TError,
        { id: number; assignmentId: number },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof removeCommissionGroupMember>>,
    TError,
    { id: number; assignmentId: number },
    TContext
> => {
    const mutationKey = ['removeCommissionGroupMember'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof removeCommissionGroupMember>>,
        { id: number; assignmentId: number }
    > = (props) => {
        const { id, assignmentId } = props ?? {};

        return removeCommissionGroupMember(id, assignmentId);
    };

    return { mutationFn, ...mutationOptions };
};

export type RemoveCommissionGroupMemberMutationResult = NonNullable<
    Awaited<ReturnType<typeof removeCommissionGroupMember>>
>;

export type RemoveCommissionGroupMemberMutationError = APIErrorResponseResponse;

/**
 * @summary Remove a member from a commission group
 */
export const useRemoveCommissionGroupMember = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof removeCommissionGroupMember>>,
        TError,
        { id: number; assignmentId: number },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof removeCommissionGroupMember>>,
    TError,
    { id: number; assignmentId: number },
    TContext
> => {
    const mutationOptions = getRemoveCommissionGroupMemberMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get bookings for a commission group
 */
export const getCommissionGroupBookings = (
    id: number,
    params?: GetCommissionGroupBookingsParams,
    signal?: AbortSignal,
) => {
    return customInstance<CommissionGroupBookingsSuccessResponseResponse>({
        url: `/commission-groups/${id}/bookings`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetCommissionGroupBookingsQueryKey = (
    id?: number,
    params?: GetCommissionGroupBookingsParams,
) => {
    return [`/commission-groups/${id}/bookings`, ...(params ? [params] : [])] as const;
};

export const getGetCommissionGroupBookingsQueryOptions = <
    TData = Awaited<ReturnType<typeof getCommissionGroupBookings>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    params?: GetCommissionGroupBookingsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getCommissionGroupBookings>>,
            TError,
            TData
        >;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCommissionGroupBookingsQueryKey(id, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommissionGroupBookings>>> = ({
        signal,
    }) => getCommissionGroupBookings(id, params, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getCommissionGroupBookings>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetCommissionGroupBookingsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getCommissionGroupBookings>>
>;
export type GetCommissionGroupBookingsQueryError = APIErrorResponseResponse;

/**
 * @summary Get bookings for a commission group
 */

export function useGetCommissionGroupBookings<
    TData = Awaited<ReturnType<typeof getCommissionGroupBookings>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    params?: GetCommissionGroupBookingsParams,
    options?: {
        query?: UseQueryOptions<
            Awaited<ReturnType<typeof getCommissionGroupBookings>>,
            TError,
            TData
        >;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetCommissionGroupBookingsQueryOptions(id, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}
